import { createContext, useContext } from 'react';
var WapTimezoneContext = createContext({
    timezone: null,
    setTimezone: function () { return undefined; },
});
export var useWapTimezone = function () { return useContext(WapTimezoneContext); };
export default WapTimezoneContext;
